export enum LeasingOfferStatus {
  ACTIVE = 'ACTIVE',
}

export enum LeasingType {
  OPERATIONAL = 'Operativni',
  FINANCIAL = 'Financijski',
}

export enum ReferentInterestRate {
  EURIBOR3M = '3M EURIBOR',
  EURIBOR3MV2 = '3 M EURIBOR',
  EURIBOR6M = '6M EURIBOR',
  EURIBOR6MV2 = '6 M EURIBOR',
  EURIBOR12M = '12M EURIBOR',
  EURIBOR12MV2 = '12 M EURIBOR',
}

export enum LeasingRecipientType {
  FIZICKA_OSOBA = 'Fizička osoba',
}

export enum InterestRateType {
  FIXED = 'Fiksna',
  VARIABLE = 'Promjenjiva',
}

export interface LeasingOffer {
  id: number;
  number: number;
  numberText?: string;
  creationDate?: Date;
  leasingObject?: string;
  leasingObjectMake?: string;
  leasingObjectModel?: string;
  leasingTypeName?: string;
  status?: LeasingOfferStatus;
  daysUntilExpiration?: string;
}

export interface LeasingCalculatorRemainingValue {
  financingDuration?: number;
  participationAmount?: number;
}

export interface LeasingOfferDetails extends LeasingOffer {
  financingDuration?: number;
  leasingObject?: string;
  supplier?: string;
  interestRate?: number;
  interestRateType?: InterestRateType;
  referentInterestRate?: string;
  indexValue?: number;
  margin: number;
  paymentPeriod?: string;
  numberOfAnnuities?: number;
  quantity?: number;
  leasingDetails?: LeasingObjectDetails[];
  participationAmount?: number;
  totalAmountInEuro?: number;
  allowedUsageLevel?: number;
  effectiveInterestRate?: number;
  offerContent?: string;
  contactPhone?: string;
  contactEmail?: string;
}

export interface LeasingObjectDetails {
  id: number;
  name: string;
  currency?: string;
  percentage?: number;
  amounts?: Amounts;
}

export interface Amounts {
  total?: number;
  taxes?: number;
  totalWithoutTaxes?: number;
}
